import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useErrorContext } from '@qpr/client-library';
import React, { useEffect, useState } from 'react';
import { isValidId } from '../../../utils/url-utils';
import initialState from '../business-model-canvas-state';
import BusinessModelCanvas from '../components/BusinessModelCanvas';
import { BMCViewModelType } from './business-model-canvas-view-model';

const PREFIX = 'BusinessModelCanvasView';

const classes = {
  pageTitleFont: `${PREFIX}-pageTitleFont`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.pageTitleFont}`]: {
    padding: theme.spacing(3),
    color: theme.palette.getContrastText(theme.palette.text.primary)
  }
}));

interface BusinessModelCanvasViewProps {
  BMCViewModel: BMCViewModelType;
}

const BusinessModelCanvasView = ({ BMCViewModel }: BusinessModelCanvasViewProps) => {
  const viewModel: BMCViewModelType = BMCViewModel;

  const [state, setState] = useState(initialState);
  const [inited, setInited] = useState(false);
  const { setError } = useErrorContext();

  useEffect(() => {
    setInited(false);
    async function initData() {
      if (!isValidId(viewModel.getId())) {
        setError({
          message: 'Invalid parameter.',
          details: `element id malformed ${viewModel.getId()}`
        });
        setInited(true);
        return;
      }

      setError(null);
      const data = await viewModel.getData();
      setState(data);
      setInited(true);
      if (data.error.message) setError(data.error);
    }
    initData();
  }, [viewModel.getId()]);

  return (
    <Root>
      <Typography variant="h6" className={classes.pageTitleFont}>
        Business model
      </Typography>
      <BusinessModelCanvas elements={state.elements} inited={inited} />
    </Root>
  );
};

export default BusinessModelCanvasView;
